import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import GaugeChartView  from 'report/GaugeChartView.js';


class ControlGaugeChartFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.mainLength = '7';
        attributes.styleBGColorText = '#FFFFFF';
        attributes.minValue = 0;
        attributes.maxValue = 100;
        attributes.dialRightColor = '#E05333';
        attributes.dialLeftColor = '#00FF00';
        attributes.needleColor = '#0000FF';
        attributes.Columns = { Column: [{id:'0', Properties: {
            usesExpression: "false",
            formatoption: "",
            fieldId: "",
            width: "150",
            format: "none",
            caption: "",
            sortType: "none",
            visible: "true",
            setDynamicFilter: "false",
            align: "left",
            aggregation: "count",
            fieldDataType: "",
            sortOrder: "0"
        }} ]};
        attributes.resizePadding = 0;
        attributes.resizePaddingH = -4;
		attributes.minWidth = 100;
		attributes.minHeight = 150;
        attributes.lowestHeight = 150;
        
        attributes.additiveDynamicFilter = 'true'; 
        attributes.respectDynamicFilter = 'true'; 
        attributes.setDynamicFilter = 'true';   

        const view = new GaugeChartView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );

        return view;
    }

}

const controlGaugeChartFactory = new ControlGaugeChartFactory();

export default controlGaugeChartFactory;